export const HEADER_GROUP = [
    {
        title: "예약현황",
        path: "/status",
        id: "status",
    },
    {
        title: "예약하기",
        path: "/reserve",
        id: "reserve",
    },
    {
        title: "예약조회",
        path: "/bookingCheck",
        id: "bookingCheck bookingConfirm",
    },
];
